import { FC } from "react";
import { PageTitle } from "../components/common/PageTitle";
import CommonPage from "../components/page/CommonPage";
import TerminalImportConfirmation from "../components/terminal/TerminalImportConfirmation";


const TerminalImportConfirmationPage : FC= () => {
  return (
    <CommonPage selectBtnIndex={2} >
      <PageTitle title="端末インポート確認" />
      <TerminalImportConfirmation />
    </CommonPage>
  );
};

export default TerminalImportConfirmationPage;
